import { arrayOf, bool, shape, string } from 'prop-types';
import React, { Fragment } from 'react';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { connect } from 'react-redux';
import LazyLoad from 'components/LazyLoad';
import {
  STICKY_AD_SIZE_MAPPING,
  SPONSORED_PUSHER_SIZE_MAPPING
} from 'constants/ads/sizes';
import { BASE_AD_UNITS } from 'constants/ads/units';
import Ad from 'components/Ad';
import SitePostBundle from 'components/SitePostBundle';
import StickyBanner from 'components/StickyBanner';
import { POST } from 'constants/pageTypes';

const Outbrain = dynamic(() => import('components/Outbrain'), {
  ssr: false,
  loading: () => null
});

const PostPusher = dynamic(() => import('components/PostPusher'), {
  ssr: false,
  loading: () => null
});

const PromotionalRibbon = dynamic(
  () => import('components/PromotionalRibbon'),
  {
    ssr: false
  }
);

export function SitePostLayout(props) {
  const { pageType, hideAds, isSponsored, data } = props;
  const { canonical, ads = {} } = data;
  // This is the current URL's page type as set by App
  const isPost = pageType === POST;

  return (
    <Fragment>
      {isPost && (
        <Head>
          <link key="amphtml" rel="amphtml" href={`${canonical}?amp=1`} />
        </Head>
      )}
      <div className="SitePostLayout">
        {!isSponsored && <PromotionalRibbon />}
        <SitePostBundle {...props} isPost={isPost} />

        {isPost && !(hideAds || isSponsored) && (
          <Fragment>
            <Ad
              unit={`${BASE_AD_UNITS.post}/Sponsored_Pusher`}
              sizes={SPONSORED_PUSHER_SIZE_MAPPING}
              targeting={ads.targeting}
              pusher={pusherProps => <PostPusher {...pusherProps} />}
            />
            <StickyBanner>
              <Ad
                unit={`${BASE_AD_UNITS.post}/Sticky`}
                targeting={ads.targeting}
                sizes={STICKY_AD_SIZE_MAPPING}
                sizeLabel="post-small"
                refreshInterval={20}
              />
            </StickyBanner>
          </Fragment>
        )}

        {/* Hide Outbrain if post is sponsored */}
        {isPost && !isSponsored && (
          <LazyLoad height={300} once>
            <div className="SitePostLayout__outbrain">
              <Outbrain src={canonical} />
            </div>
          </LazyLoad>
        )}
      </div>
    </Fragment>
  );
}

SitePostLayout.propTypes = {
  data: shape({
    canonical: string,
    categories: arrayOf(
      shape({
        name: string,
        slug: string
      })
    ),
    tags: arrayOf(
      shape({
        name: string,
        slug: string
      })
    )
  }).isRequired,
  pageType: string,
  hideAds: bool.isRequired,
  hideComments: bool.isRequired,
  hideAccountActions: bool.isRequired,
  isAffiliate: bool.isRequired,
  isDraft: bool.isRequired,
  isNoIndex: bool.isRequired,
  isSponsored: bool.isRequired
};

SitePostLayout.defaultProps = {
  pageType: POST
};

const mapStateToProps = state => ({
  pageType: state.page.pageType
});

export default connect(
  mapStateToProps,
  null
)(SitePostLayout);
